import {inject, injectable} from "inversify";
import {Region} from "@/modules/base/entity";
import chance from "@/modules/base/services/chance";
import {EventEmitter} from "@/modules/base/events";
import ActionScreener from "@/modules/action-screens/services/ActionScreener";
import YouthPlayerFactory from "@/modules/youth/services/factories/YouthPlayerFactory";
import {Team} from "@/modules/team/entity";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

@injectable()
export class RegionScoutingEvaluator {
  private readonly progressRangePerAction: { min: number, max: number, fixed: number };

  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ActionScreener) private actionScreener: ActionScreener,
    @inject(YouthPlayerFactory) private youthPlayerFactory: YouthPlayerFactory,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
    this.progressRangePerAction = this.configRepository.get('youth.scouting.region.progressRangePerAction');
  }

  public async evaluate(region: Region) {
    const team = await Team.current();

    const incProgress = chance.floating(this.progressRangePerAction);

    console.debug(`region ${region.name} total skill progress`, incProgress);

    let progress = Math.min(100, region.newPlayerProgress + incProgress);

    if (progress === 100) {
      progress = 0;

      await this.youthPlayerFactory.generate(region, 1, player => {
        player.team = team;
        player.revelation = 0;
      });

      // todo
      // await this.actionScreener.show({
      //   component: NewYouthPlayerActionScreen,
      //   props: task,
      // });
    }

    region.newPlayerProgress = progress;
    await region.save();
  }
}